export default __webpack_public_path__ + "static/media/panTech5.7662714f.png";